var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcFriendsHeader(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "38px",
    height: "29px",
    viewBox: "0 0 38 29",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icFriendsHeader") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD-header4-Final-Home-with-submenu",
    transform: "translate(-1129.000000, -196.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(1079.000000, 64.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Top",
    transform: "translate(16.000000, 27.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Friends",
    transform: "translate(0.000000, 90.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(28.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Friends",
    transform: "translate(6.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1168539,28.4716599 L12,22.4251012 L20.1213483,19.3724696 L19.1280899,13.2672065 C17.0831461,10.1558704 19.1280899,9.15789474 19.1280899,9.15789474 L18.1348315,5.10728745 C19.1865169,0 25.2629213,0 25.2629213,0 C30.3460674,0 32.3910112,5.048583 32.3910112,5.048583 L31.3977528,9.09919028 C33.4426966,10.1558704 31.3977528,13.208502 31.3977528,13.208502 L29.352809,19.3137652 L38,23.8927126 L38,29 L12.1168539,28.4716599 Z M0,26 L0,21.1039604 L6.4,18.6559406 L5.6,13.7029703 C4,11.1980198 5.6,10.4009901 5.6,10.4009901 L4.8,7.0990099 C5.6,3 10.4,3 10.4,3 C14.4,3 16,7.0990099 16,7.0990099 L15.2,10.4009901 C16.8,11.2549505 15.2,13.7029703 15.2,13.7029703 L14.4,18.029703 L15.3714286,18.9975248 L9.42857143,20.990099 L9.42857143,25.9430693 L0,26 Z",
    id: "icFriendsHeader"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFriendsHeader);
export default __webpack_public_path__ + "static/media/icFriendsHeader.9a893e6dae732552d30af6b836d95391.svg";
export { ForwardRef as ReactComponent };